import { Category, Message, MessageWithContent, TeamMessage } from './types'

export function getInitials(name?: string | null): string {
  if (!name) return ''
  const parts = name.split(' ')
  if (parts.length === 1) return parts[0][0]
  return `${parts[0][0]}${parts[1][0]}`
}

export function constructShareMessage(message: MessageWithContent | TeamMessage): string {
  if (isTeamMessage(message)) {
    return message.title
  }
  return `${message.sanity.title}: ${message.sanity.subtitle}`
}

export function isTeamMessage(message: { category: string }): message is TeamMessage {
  return message.category.toLowerCase() === Category.Team.toLowerCase()
}

export function parseTeamMessageContent(messages: Message[]): TeamMessage[] {
  return messages.map((message) => {
    const content = JSON.parse(message.content) as { title: string; body: string }
    return { ...message, category: Category.Team, title: content.title, body: content.body }
  })
}
